// removed by extract-text-webpack-plugin
module.exports = {"loaderText":"loaderText__zO9tJ","buttonOpacity":"buttonOpacity__3yHwu"};


//////////////////
// WEBPACK FOOTER
// ./components/requestButton/style.css
// module id = DFtG
// module chunks = 444